import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import WordEntryPage from './pages/WordEntryPage';
import OurStoryPage from './pages/OurStoryPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import BlogAdminPage from './pages/BlogAdminPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import SATVocabularyPage from './pages/SATVocabularyPage';
import TOEFLVocabularyPage from './pages/TOEFLVocabularyPage';
import Oxford5000VocabularyPage from './pages/Oxford5000VocabularyPage';
import ElementaryVocabularyPage from './pages/ElementaryVocabularyPage';
import HighSchoolVocabularyPage from './pages/HighSchoolVocabularyPage';
import MiddleSchoolVocabularyPage from './pages/MiddleSchoolVocabularyPage';
import './App.css';

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <div className="App">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/word/:word" element={<WordEntryPage />} />
          <Route path="/our-story" element={<OurStoryPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/collections/sat" element={<SATVocabularyPage />} />
          <Route path="/collections/toefl" element={<TOEFLVocabularyPage />} />
          <Route path="/collections/oxford" element={<Oxford5000VocabularyPage />} />
          <Route path="/collections/elementary" element={<ElementaryVocabularyPage />} />
          <Route path="/collections/middle" element={<MiddleSchoolVocabularyPage />} />
          <Route path="/collections/high" element={<HighSchoolVocabularyPage />} />
          <Route 
            path="/admin/blog" 
            element={
              <ProtectedRoute>
                <BlogAdminPage />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 